import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { UserService } from './../../service/user.service';
import Popup from 'reactjs-popup';
import ChangePassword from './ChangePassword';
import Confirmation from '../common/Confirmation';
import Alert from '../common/Alert';

import '../../../node_modules/reactjs-popup/dist/index.css';
import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const UserItem = (params) => {
    const [user, setUser] = useState();
    const [country, setCountry] = useState();
    const [countries, setCountries] = useState([]);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState();
    const [supervisorName, setSupervisorName] = useState();
    const [supervisorEmail, setSupervisorEmail] = useState();
    const [sponsorName, setSponsorName] = useState();
    const [sponsorEmail, setSponsorEmail] = useState();
    const [userApplication, setApplication] = useState([]);
    const [userStatus, setUserStatus] = useState({})
    const [message, setMessage] = useState([]);
    const [primaryApplication, setPrimaryApplication] = useState({});
    const [status, setStatus] = useState([
        { value: 1, label: "Active" },
        { value: 2, label: "Locked" },
        { value: 3, label: "Deleted" }
    ]);
    const [passwordNeverExpires, setPasswordNeverExpires] = useState(false);
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    const userService = new UserService();

    const setFormInput = (e, tag = undefined) => {
        if (e.target !== undefined) {
            tag = e.target.name;
        }

        if (tag === "firstName") {
            setFirstName(e.target.value);
            removeMessage(1);
        }
        else if (tag === "lastName") {
            setLastName(e.target.value);
            removeMessage(2);
        }
        else if (tag === "userphone") {
            setPhone(e.target.value);
            removeMessage(3);
        }
        else if (tag === "managername") {
            setSupervisorName(e.target.value);
            removeMessage(4);
        }
        else if (tag === "manageremail") {
            setSupervisorEmail(e.target.value);
            removeMessage(5);
        }
        else if (tag === "sponsorname") {
            setSponsorName(e.target.value);
            removeMessage(6);
        }
        else if (tag === "sponsoremail") {
            setSponsorEmail(e.target.value);
            removeMessage(7);
        }
        else if (tag === "userStatus") {
            setUserStatus(e.target.value);
            removeMessage(9);
        }
        else if (tag === "passwordNeverExpires") {
            setPasswordNeverExpires(e.target.checked)
        }
    };

    const removeMessage = (id) => {
        if (message.length > 0) {
            let newMessage = message.filter((m) => {
                return (m.id !== id);
            });
            setMessage(newMessage);
        }
    };

    const checkValidation = () => {
        let result = true;
        let newMessage = [];

        let regex = new RegExp('[a-z0-9]+@[a-z0-9]+\.[a-z]{2,3}');

        if (!firstName || firstName.length === 0) {
            newMessage.push({ id: 1, text: "User's' first name is required" });
            result = false;
        }

        if (!lastName || lastName.length === 0) {
            newMessage.push({ id: 2, text: "User's last Name is required" });
            result = false;
        }


        if (!user.email || user.email.length === 0) {
            newMessage.push({ id: 3, text: "User's email' is required" });
            result = false;
        }

        if (!regex.test(user.email)) {
            newMessage.push({ id: 3, text: "User's email' is not valid" });
            result = false;
        }

        if (checkIsSponsorCompanyUser(user.sponsorCompanyId)) {
            if (!sponsorName || sponsorName.length === 0) {
                newMessage.push({ id: 6, text: "User's sponsor name is required" });
                result = false;
            }

            if (!sponsorEmail || sponsorEmail.length === 0) {
                newMessage.push({ id: 7, text: "User's sponsor email is required" });
                result = false;
            }

            if (!regex.test(sponsorEmail)) {
                newMessage.push({ id: 8, text: "User's sponsor email' is not valid" });
                result = false;
            }
        }
        else {
            if (!supervisorName || supervisorName.length === 0) {
                newMessage.push({ id: 4, text: "User's supervisor/manager name is required" });
                result = false;
            }

            if (!supervisorEmail || supervisorEmail.length === 0) {
                newMessage.push({ id: 5, text: "User's supervisor/manager email is required" });
                result = false;
            }

            if (!regex.test(supervisorEmail)) {
                newMessage.push({ id: 5, text: "User's supervisor email' is not valid" });
                result = false;
            }
        }

        if (userStatus.value < 1 || userStatus.value > 3) {
            newMessage.push({ id: 9, text: "Invalid user status, user should be Active/Locked/Deleted" });
            result = false;
        }

        setMessage(newMessage);
        return result;
    };

    const addRemoveApplication = (apps) => {
        let uap = user.applications.map(function (a) {
            return a.value;
        });

        let selectedUap = apps.filter((p) => {
            return uap.includes(p.value);
        });

        if (selectedUap.length < apps.length) {
            alert("You can't add a new application from profile, Please apply for that application from application page");
        }
        setApplication(selectedUap);
    };

    const checkIsSponsorCompanyUser = (sponsorCompanyId) => {
        return (sponsorCompanyId !== null && sponsorCompanyId !== undefined && sponsorCompanyId !== 0);
    }

    useEffect(() => {
        const fetchData = async () => {
            const result = await userService.getUserById(params.id);
            
            setUser(result.data);
            setFirstName(result.data.firstName);
            setLastName(result.data.lastName);

            if (result.data.userStatus) {
                setUserStatus({
                    value: result.data.userStatus,
                    label: (result.data.userStatus === 1 ? "Active" : (result.data.userStatus === 2 ? "Locked" : "Deleted"))
                });
            }

            if (result.data.phone) {
                setPhone(result.data.phone);
            }
            if (result.data.supervisorName) {
                setSupervisorName(result.data.supervisorName);
            }

            if (result.data.supervisorEmail) {
                setSupervisorEmail(result.data.supervisorEmail);
            }

            if (result.data.sponsorName) {
                setSponsorName(result.data.sponsorName);
            }

            if (result.data.sponsorEmail) {
                setSponsorEmail(result.data.sponsorEmail);
            }

            setCountries(result.data.countries.map(function (x) {
                return { value: x.id, label: x.name };
            }));

            if (result.data.country) {
                setCountry({ value: result.data.country.id, label: result.data.country.name });
            };

            if (result.data.userApplication) {
                let _userApp = result.data.userApplication.map(function (a) {
                    return a.applicationId;
                });

                setApplication(result.data.applications.filter((app) => {
                    return _userApp.includes(app.value);
                }));
            }

            if (result.data.passwordNeverExpires) {
                setPasswordNeverExpires(result.data.passwordNeverExpires);
            }

            const prymaryApp = await userService.getprimaryapplicationbyuserId(params.id)
            if (prymaryApp.data) {
                setPrimaryApplication({ id: prymaryApp.data.id, name: prymaryApp.data.name });
            }
        }

        fetchData()
            .catch(console.error);
    }, []);

    const onSuccess = async () => {
        if (checkValidation() === true) {
            console.log("I am going to save it!");
            let userModel = {
                id: (user.id ? user.id : 0),
                firstName: firstName,
                lastName: lastName,
                email: user.email,
                phone: phone ? phone : "",
                supervisorName: supervisorName,
                supervisorEmail: supervisorEmail,
                sponsorName: sponsorName,
                sponsorEmail: sponsorEmail,
                companyId: user.companyId,
                countryId: user.countryId,
                regionId: user.regionId,
                businessUnitId: user.businessUnitId,
                officeLocationId: user.officeLocationId,
                dateCreated: new Date(),
                dateModified: new Date(),
                userApplication: userApplication,
                status: userStatus.value,
                passwordNeverExpires: (passwordNeverExpires === '' ? 0 : (passwordNeverExpires === true ? 1 : 0)),
            }
                        
            let saveResult = await userService.updateUser(userModel);
            if (saveResult.status === 200 && saveResult.data.isSuccess === true) {
                setAlertMessage("User's data has been saved successfully");
                alertOn(true);
                params.callBack();
            }
            else {
                setAlertMessage(saveResult.data.message);
                alertOn(true);
            }
        }
    }

    const alertOff = () => {
        setIsAlert(false);
        params.onClose();
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            <div className="card" style={{ width: "975px", marginTop: "-5px", marginLeft: "-5px", marginBottom: "-5px", marginRight: "-5px" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> User
                </h5>
                <div className="card-body">
                    <div>
                        {(message.length > 0) ?
                            <ul>
                                {message.map(m =>
                                    <li style={{ color: "red" }} key={m.id}>{m.text}</li>
                                )}
                            </ul>
                            : ""}
                    </div>
                    <div className="ag-theme-alpine" style={{ height: "450px", marginRight: "-15px", overflowY: "auto" }}>
                        {
                            user ?
                                <div style={{ width: "915px" }}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>First Name</label>
                                                <input type="text" onChange={e => setFormInput(e)} value={firstName} className="form-control" id="firstName" name="firstName" />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Last Name</label>
                                                <input type="text" onChange={e => setFormInput(e)} value={lastName} className="form-control" id="lastName" name="lastName" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group" disabled="disabled">
                                                <label>Company</label>
                                                <input type="text" value={user.company.name} className="form-control" id="firstName" name="companyName" required readOnly />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Country</label>
                                                <Select defaultValue={country} options={countries} isDisabled="true" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Email</label>
                                                <input type="email" value={user.email} className="form-control" id="useremail" readOnly />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Phone</label>
                                                <input type="text" onChange={e => setFormInput(e)} value={phone} className="form-control" id="userphone" name="userphone" />
                                            </div>
                                        </div>
                                    </div>

                                    {(checkIsSponsorCompanyUser(user.sponsorCompanyId)) ?
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Sponsor Name</label>
                                                    <input type="text" onChange={e => setFormInput(e)} value={sponsorName} className="form-control" id="sponsorname" name="sponsorname" />

                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Sponsor Email</label>
                                                    <input type="email" onChange={e => setFormInput(e)} value={sponsorEmail} className="form-control" id="sponsoremail" name="sponsoremail" />

                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="row" >
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Manager Name</label>
                                                    <input type="text" onChange={e => setFormInput(e)} value={supervisorName} className="form-control" id="managername" name="managername" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Manager Email</label>
                                                    <input type="email" onChange={e => setFormInput(e)} value={supervisorEmail} className="form-control" id="manageremail" name="manageremail" />
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="row" >
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>User Status</label>
                                                        <Select style={{ maxHeight: "100px" }} defaultValue={userStatus} options={status} onChange={(e) => { setUserStatus(e); removeMessage(9); }} />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Primary Application</label>
                                                        <input type="text" className="form-control" value={primaryApplication?.name ?? ""} readOnly />
                                                    </div>                                                    
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label for="sponsorname">Business Unit</label>
                                                        <input type="businessUnitName" value={user.businessUnit ? user.businessUnit.name : ''} className="form-control" id="businessUnitName" name="businessUnitName" readOnly />
                                                    </div>

                                                    <div className="form-group" style={{ paddingTop: "25px" }}>
                                                        <input id="passwordNeverExpires" name="passwordNeverExpires" type="checkbox" checked={passwordNeverExpires} onChange={e => setFormInput(e)} />
                                                        <label className="pl-2">Password Never Expires</label>
                                                    </div>                                                   
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Application</label>
                                                <Select style={{ maxHeight: "100px" }} isMulti defaultValue={userApplication} options={userApplication} onChange={(e) => { addRemoveApplication(e) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : <h3 className="loading">Loading ..... ... .</h3>
                        }

                    </div>
                </div>
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <Popup trigger={<button className="btn btn-secondary" style={{ marginRight: "5px" }}>Save</button>} nested modal>{close => (<Confirmation hideAction="false" title="Save User" message="Are you sure, you want to save this user information?" buttonCaption="Save" onSuccess={onSuccess} onClose={() => { close(); }}></Confirmation>)}</Popup>
                        <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                        <Popup trigger={<button style={{ marginLeft: "15px" }} type="button" className="btn btn-secondary">Change Password</button>} nested modal>{close => (<ChangePassword data={user} applicationId={primaryApplication?.id ?? 0} onClose={() => { close(); }}></ChangePassword>)}</Popup>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserItem;